import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// import { FormattedMessage } from 'react-intl';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { getInstrumentedAxiosInstance } from '../../../../globs/ajax-proxy';
import NoImage from '../../combined-shape.svg';
import config from '../../../../globs/config';
class Slider extends Component {

  state = {
    currImgIdx: null,
  }

  componentDidMount() {
    const { props } = this;
    // console.log('data', props.data);
    let currentImgData = null;
    let currImgIdx = null;
    props.data.forEach((ele, idx) => {
      if (ele.id === props.imageDataId) {
        currImgIdx = idx;
        currentImgData = ele;
      }
    });
    this.setState({
      currImgIdx,
      currentImgData,
    });
  }

  handleDownLoadClick = () => {
    const { props, state } = this;
    // const url = `${props.user._links.business.href}/complaint/download_file`;
    const url = `${config.apiContextPath}/sales_officers/${props.user.id}/businesses/${props.customerId}/complaint/download_file`;
    const imgData = state.currentImgData.file_url_data;
    console.log('imgData', imgData);
    getInstrumentedAxiosInstance().post(url, { file_id: imgData.file_id })
      .then((res) => {
        console.log('res', res);
        const fileUrl = res.data.file_url;
        window.open(fileUrl, '_blank');
      });
  }

  handleImageChange = (currImgIdx) => {
    const { props } = this;
    const currImage = props.data[currImgIdx];
    const currentImgData = props.data.filter(ele => ele.id === currImage.id)[0];
    this.setState({
      currImgIdx,
      currentImgData,
    });
  }

  render() {
    const { state: { currImgIdx }, props } = this;
    return (
      <div className="custom-modal-bg-cover">
        <div className="lr-modal-bg-cover">
          <div className="lr-delete-customer-modal image-view">
            {/* <p>Uploaded On 05.11.2019</p> */}
            {/* <p>{state.imageUploadedOn}</p> */}
            <h6>
              {/* <FormattedMessage id="UploadedOn" /> */}
             <span>Uploaded On</span> : {moment(props.createat).format('DD-MM-YYYY')}</h6>
            <i className="icon-close" onClick={props.closePop} />
            {/* <img src={state.imageUrl} /> */}
            <div className="popup-carousel">
              <Carousel selectedItem={currImgIdx} onChange={this.handleImageChange}>
                {
                    props.data.map((img) => {
                      const imagePath = img.file_url_data.file_type;
                      return (
                        <div key={img.id}>
                          { (imagePath !== 'pdf' && imagePath !== 'doc' && imagePath !== 'docx' && imagePath !== 'xls' && imagePath !== 'xlsx') ?
                            <img src={img.file_url} /> :
                            <img className="view-img" src={NoImage} />
                          }
                        </div>
                      );
                    })
                }
              </Carousel>
            </div>
            <button onClick={this.handleDownLoadClick}>
              <span>DOWNLOAD</span>
              {/* <FormattedMessage id="Download" /> */}
            </button>
          </div>
        </div>
      </div>

    );
  }
}

Slider.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  closePop: PropTypes.func.isRequired,
  imageDataId: PropTypes.number,
  createat: PropTypes.string.isRequired,
  customerId: PropTypes.string,
};

Slider.defaultProps = {
  imageDataId: null,
};

export default Slider;
